import { ObjectField } from "components/Form/ObjectField"

export const AddressExpandedField = (props) => {
  props.schema.properties.city.widget = "city"

  return <ObjectField {...props} />
}
